import { TIndicatorMonitoringState } from './types';

export function getMonitoringPage(state: TIndicatorMonitoringState) {
  return state.monitoringPage;
}

export function getUpdateStatuses(state: TIndicatorMonitoringState) {
  return state.updateStatuses;
}

export function getSources(state: TIndicatorMonitoringState) {
  return state.sources;
}

export function getLoadError(state: TIndicatorMonitoringState) {
  return state.loadError;
}
